import React, { useState, useEffect, useContext } from "react";
import { Link, useSearchParams } from "react-router-dom";
import ReactSlider from "react-slider";
import useProductCategory from "../../hooks/useProductCategory";
import useProductList from "../../hooks/useProductList";
import { useAppConfig } from "../../context/AppConfigContext";
import {
  formatCurrencyLocal,
  formatNumberLocal,
} from "../../utils/stringManipulator";

const Product = ({ isWholesale = false }) => {
  const { config } = useAppConfig();
  const {
    fetchProductCategory,
    data: productCategory,
    status: productCategoryStatus,
    error: productCategoryError,
  } = useProductCategory();

  const {
    fetchProductList,
    data: productList,
    total: productListTotal,
    status: productListStatus,
    error: productListError,
  } = useProductList();

  const [searchParams, setSearchParams] = useSearchParams();
  const keyword = searchParams.get("category");

  let [grid, setGrid] = useState(false);
  let [active, setActive] = useState(false);

  const [sortBy, setSortBy] = useState("name-asc");

  const [filterCategoryId, setFilterCategoryId] = useState(undefined);
  const [page, setPage] = useState(0);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isFirstPage, setIsFirstPage] = useState(true);

  useEffect(() => {
    fetchProductCategory();
  }, []);

  useEffect(() => {
    if (keyword) {
      setFilterCategoryId(keyword);
    }
  }, [keyword]);

  useEffect(() => {
    fetchProductList({
      categoryIds: keyword ?? filterCategoryId,
      sortBy: sortBy.split("-")[0],
      sortType: sortBy.split("-")[1],
      skip: page * 25,
      take: page === 0 ? 25 : 25,
      isGrosir: isWholesale,
    });
  }, [filterCategoryId, page, sortBy, isWholesale]);

  useEffect(() => {
    //console.log(productListStatus);
    if (productListStatus === "done") {
      setIsLastPage(page + 1 === Math.ceil(productListTotal / 25));
      setIsFirstPage(page === 0);
    }
  }, [productListStatus]);

  const setAllCategory = () => {
    setFilterCategoryId(undefined);
    setPage(0);
  };

  const setSelectedGallery = (id) => {
    setFilterCategoryId(id);
    setPage(0);
  };

  const totalPages = Math.ceil(productListTotal / 25);

  const getPageNumbers = () => {
    const candidates = new Set([0, totalPages - 1, page - 1, page, page + 1]);
    const validCandidates = Array.from(candidates)
      .filter((p) => p >= 0 && p < totalPages)
      .sort((a, b) => a - b);

    const result = [];
    for (let i = 0; i < validCandidates.length; i++) {
      if (i > 0 && validCandidates[i] - validCandidates[i - 1] > 1) {
        result.push("...");
      }
      result.push(validCandidates[i]);
    }
    return result;
  };

  let sidebarController = () => {
    setActive(!active);
  };

  return (
    <section className="shop py-40">
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className="container container-md">
        <div className="row">
          {/* Sidebar Start */}
          <div className="col-xxl-3 col-lg-3">
            <div className={`shop-sidebar ${active && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-one-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-one-600"
              >
                <i className="ph ph-x" />
              </button>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-20 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Product Category
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  <li
                    className={
                      filterCategoryId === undefined
                        ? "text-main-one-600 text-sm mb-10"
                        : "mb-16 text-sm"
                    }
                  >
                    <Link
                      to={`#`}
                      onClick={() => setAllCategory()}
                      className={
                        filterCategoryId === undefined
                          ? "w-100 text-white text-sm bg-main-one-600 border border-gray-100 rounded-8 py-10 px-20"
                          : "text-gray-900 hover-text-main-one-600"
                      }
                    >
                      ALL CATEGORIES
                    </Link>
                  </li>
                  {Array.isArray(productCategory) &&
                    productCategory.length > 0 &&
                    productCategory.map((item, index) => (
                      <li
                        className={
                          filterCategoryId === item.id
                            ? "text-main-one-600 text-sm mb-10"
                            : "mb-16 text-sm"
                        }
                        key={index}
                      >
                        <Link
                          to={`#`}
                          onClick={() => setSelectedGallery(item.id)}
                          className={
                            filterCategoryId === item.id
                              ? "w-100 text-white text-sm bg-main-one-600 border border-gray-100 rounded-8 py-10 px-20"
                              : "text-gray-900 hover-text-main-one-600 text-sm"
                          }
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          {/* Sidebar End */}
          {/* Content Start */}

          <div className="col-xxl-9 col-lg-9" style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
                //backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: "999",
                display: productListStatus === "loading" ? "block" : "none",
              }}
            >
              <img
                src="assets/images/icon/preloader.gif"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "50%",
                  marginTop: "100px",
                  transform: "translate(-50%, -50%)",
                }}
                alt=""
              />
            </div>
            <div className="flex-between gap-16 flex-wrap mb-40 ">
              {productListTotal > 0 ? (
                <>
                  <span className="text-gray-900 text-md">
                    Showing {page * 25 + 1}-
                    {productListTotal < 26 ? productListTotal : page * 25 + 25}{" "}
                    of {productListTotal} result
                  </span>
                  <div className="position-relative flex-align gap-16 flex-wrap">
                    <div className="list-grid-btns flex-align gap-16">
                      <button
                        onClick={() => setGrid(true)}
                        type="button"
                        className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                          grid === true &&
                          "border-main-600 text-white bg-main-one-600"
                        }`}
                      >
                        <i className="ph-bold ph-list-dashes" />
                      </button>
                      <button
                        onClick={() => setGrid(false)}
                        type="button"
                        className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                          grid === false &&
                          "border-main-600 text-white bg-main-one-600"
                        }`}
                      >
                        <i className="ph ph-squares-four" />
                      </button>
                    </div>
                    <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                      <label
                        htmlFor="sorting"
                        className="text-inherit flex-shrink-0"
                      >
                        Sort by:{" "}
                      </label>
                      <select
                        defaultValue={"name-asc"}
                        className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                        id="sorting"
                        onChange={(e) => setSortBy(e.target.value)}
                      >
                        <option value={"name-asc"}>Name A-Z</option>
                        <option value={"name-desc"}>Name Z-A</option>
                        <option value={"price-asc"}>Lowest Price</option>
                        <option value={"price-desc"}>Highest Price</option>
                      </select>
                    </div>
                    <button
                      onClick={sidebarController}
                      type="button"
                      className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                    >
                      <i className="ph-bold ph-funnel" />
                    </button>
                  </div>
                </>
              ) : (
                <span className="text-gray-900">No Product Found</span>
              )}
            </div>
            <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              {Array.isArray(productList) &&
                productList.length > 0 &&
                productList.map((item, index) => (
                  <div
                    key={index}
                    className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2"
                  >
                    <Link
                      to={`${isWholesale ? "/wholesale" : ""}/product-details/${encodeURIComponent(item.slug)}`}
                      className="product-card__thumb flex-center rounded-8 position-relative"
                    >
                      {item?.discountPrice > 0 &&
                        item?.discountPrice < item?.price && (
                          <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                            Sale {formatNumberLocal(Number(item?.discount))}%
                          </span>
                        )}

                      <img
                        src={
                          item.photoData && item.photoData.length > 0
                            ? item.photoData[0].url
                            : "/assets/images/no-image.png"
                        }
                        alt=""
                      />
                    </Link>
                    <div className="product-card__content w-100">
                      <h6 className="title text-lg fw-semibold mt-12 mb-8">
                        <Link
                          to={`${isWholesale ? "/wholesale" : ""}/product-details/${encodeURIComponent(
                            item.slug,
                          )}`}
                          className="link text-line-2"
                          tabIndex={0}
                        >
                          {item.name || ""}
                        </Link>
                      </h6>
                      <div className="product-card__price my-10">
                        {item?.discountPrice > 0 &&
                          item?.discountPrice < item?.price && (
                            <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                              {formatCurrencyLocal(
                                item?.price,
                                config?.currency,
                              )}
                            </span>
                          )}

                        <span className="text-heading text-md fw-semibold ">
                          {formatCurrencyLocal(
                            item?.discountPrice > 0 &&
                              item?.discountPrice < item?.price
                              ? item?.discountPrice
                              : item?.price,
                            config?.currency,
                          )}{" "}
                          <span className="text-gray-500 fw-normal">
                            /Qty
                          </span>{" "}
                        </span>
                      </div>
                      <Link
                        to={`${isWholesale ? "/wholesale" : ""}/product-details/${encodeURIComponent(item.slug)}`}
                        className="product-card__cart btn bg-main-one-50 text-heading hover-bg-main-one-600 hover-text-white py-11 px-8 text-sm rounded-8 flex-center gap-8 fw-medium"
                        tabIndex={0}
                      >
                        Add To Cart <i className="ph ph-shopping-cart" />
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
            <ul className="pagination flex-center flex-wrap gap-16">
              {productListTotal > 25 && !isFirstPage && (
                <li className="page-item">
                  <Link
                    className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                    to="#"
                    onClick={() => setPage(page > 0 ? page - 1 : 0)}
                  >
                    <i className="ph-bold ph-arrow-left" />
                  </Link>
                </li>
              )}
              {getPageNumbers().map((item, index) => {
                if (item === "...") {
                  return (
                    <li
                      className="page-item disabled"
                      key={`ellipsis-${index}`}
                    >
                      <span
                        className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                        style={{ pointerEvents: "none" }}
                      >
                        ...
                      </span>
                    </li>
                  );
                }
                return (
                  <li
                    className={`page-item ${page === item ? "active" : ""}`}
                    key={item}
                  >
                    <Link
                      className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                      to="#"
                      onClick={() => setPage(item)}
                    >
                      {String(item + 1).padStart(2, "0")}
                    </Link>
                  </li>
                );
              })}

              {productListTotal > 25 && !isLastPage && (
                <li className="page-item">
                  <Link
                    className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                    to="#"
                    onClick={() => setPage(page + 1)}
                  >
                    <i className="ph-bold ph-arrow-right" />
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
